export enum Branches {
    INCENDIO = "1",
    AUTOMOVILES = '3',
    ACCIDENTES_DEL_TRABAJO = "4",
    CRISTALES = "5",
    AUTOS_RESP_CIVIL = '6',
    RESPONSABILIDAD_CIVIL = "8",
    ROBO_Y_RIESGOS_SIMILARES = '9',
    MOTOVEHICULOS = "12",
    AERONAVEGACION = "14",
    RIESGOS_VARIOS = "15",
    SEGURO_TECNICO = "16",
    TRANSPORTES_CASCOS = "17",
    TRANSPORTE_MERCADERIAS = "18",
    GANADO = "22",
    ACCIDENTES_PERSONALES_COLECTIVO = "23",
    INTEGRAL_CONSORCIO = "26",
    COMBINADO_FAMILIAR = "27",
    INTEGRAL_COMERCIO = "28",
    VIDA_COLECTIVO = "80",
    VIDA_INDIVIDUAL_TEMPORAL = "81",
    VIDA_SALDO_DEUDOR = "84",
    SEPELIO = "85",
    TRABAJADORES_RURALES = "86",
    VIDA_OBLIGATORIO = "89",
}